import React from 'react';
import '../styles/TicketPopUp.css'

const TicketPopUp = () => {
    const downloadTicket = () => {
        alert("Downloading Ticket...");
        
    };

    const closeModal = () => {
        document.getElementById("popup-modal").style.display = "none";
    };

    return (
        <div id="popup-modal" className="modal-overlay">
            <div className="modal-box">
                <h2 className="modal-title">Yayy! Registration Successful</h2>
                <button onClick={downloadTicket} className="modal-button download">
                    Download Ticket
                </button>
                <button onClick={closeModal} className="modal-button close">
                    Close
                </button>
            </div>
        </div>
    );
};

export default TicketPopUp;
